/**
 * Cấu hình upload ảnh BĐS và avatar — accept MIME, gợi ý hiển thị.
 */
import { TEXT } from '../languages';

export const PROPERTY_IMAGE_UPLOAD = {
  accept: '.jpg,.jpeg,.png,image/jpeg,image/png',
  allowedMimeTypes: ['image/jpeg', 'image/png'],
  hint: TEXT.property.form.imagesHint,
};

export const AVATAR_IMAGE_UPLOAD = {
  accept: '.jpg,.jpeg,.png,image/jpeg,image/png',
  allowedMimeTypes: ['image/jpeg', 'image/png'],
  hint: TEXT.profile.avatarHint,
};
